export default __webpack_public_path__ + "static/media/email_sent.0fbb7756.svg";